import React from 'react'
import style from './style.module.scss'

export type BreadcrumbItemProps = {
    url: string | null
    label: string
}

type BreadcrumbProps = {
    links: BreadcrumbItemProps[]
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links }) => {
    return (
        <nav className={style.breadcrumb}>
            <ul>
                {links.map((link, i) => (
                    <li key={i}>
                        {link.url && i < links.length - 1 ? (
                            <a href={link.url}>{link.label}</a>
                        ) : (
                            <span>{link.label}</span>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    )
}

export default Breadcrumb
